<div
  *ngIf="ProductTypeMessage[product.type]"
  class="text-pink font-italic font-size-smaller line-height"
>
  {{ ProductTypeMessage[product.type] }}
</div>
